/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Ai_Stage_LearnInputs */

const en_directory_hubs_signals_ai_stage_learn = /** @type {(inputs: Directory_Hubs_Signals_Ai_Stage_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentation quality: docs, quickstart, API reference, OpenAPI spec, request and response examples, and error semantics. This is where most products lose agents. 7 checks.`)
};

const zh_directory_hubs_signals_ai_stage_learn = /** @type {(inputs: Directory_Hubs_Signals_Ai_Stage_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档质量：文档、快速上手、API 参考、OpenAPI 规范、请求/响应示例、错误语义。大多数产品在 这里把 Agent 挡在门外。7 项检查。`)
};

/**
* | output |
* | --- |
* | "Documentation quality: docs, quickstart, API reference, OpenAPI spec, request and response examples, and error semantics. This is where most products lose ag..." |
*
* @param {Directory_Hubs_Signals_Ai_Stage_LearnInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_ai_stage_learn = /** @type {((inputs?: Directory_Hubs_Signals_Ai_Stage_LearnInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Ai_Stage_LearnInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_ai_stage_learn(inputs)
	return zh_directory_hubs_signals_ai_stage_learn(inputs)
});
export { directory_hubs_signals_ai_stage_learn as "directory.hubs.signals.ai.stage.learn" }